import RecCarousel from '@/home/RecommendedCarousels/RecCarousel';
import { CarouselSkeleton } from '@/home/SkeletonLoaders';
import useGetCarouselVehicles from './hooks/useGetCarouselVehicles';
import useGetMostViewedOrMostRecentYMM from './hooks/useGetMostViewedOrMostRecentYMM';
import VehicleDetailsTileSkeleton from '../SkeletonLoaders/CarouselSkeleton/VehicleDetailsTileSkeleton';

enum CarouselType {
  BecauseYouViewed = 'Because You Viewed',
  FreeShipping = 'Vehicles With Free Shipping',
  UpYourRide = 'Upgrade Your Ride',
  BudgetFriendly = 'Budget Friendly Options',
  PriceDrops = 'Recent Price Drops'
}

export default function RecommendedCarousels() {
  const targetVehicle = useGetMostViewedOrMostRecentYMM();
  const {
    carouselVehicles: {
      becauseYouViewed,
      freeShipping,
      upYourRide,
      budgetFriendly,
      priceDrops
    },
    showCarousel
  } = useGetCarouselVehicles();

  return showCarousel ? (
    <div className="flex flex-col gap-24">
      {becauseYouViewed.length > 0 && targetVehicle && (
        <RecCarousel
          title={`${CarouselType.BecauseYouViewed} ${targetVehicle.make} ${targetVehicle.model}`}
          vehicles={becauseYouViewed}
          dataQa="because-you-viewed"
        />
      )}
      {freeShipping.length > 0 && (
        <RecCarousel
          title={CarouselType.FreeShipping}
          vehicles={freeShipping}
          dataQa="free-shipping"
        />
      )}
      {upYourRide.length > 0 && (
        <RecCarousel
          title={CarouselType.UpYourRide}
          vehicles={upYourRide}
          dataQa="up-your-ride"
        />
      )}
      {budgetFriendly.length > 0 && (
        <RecCarousel
          title={CarouselType.BudgetFriendly}
          vehicles={budgetFriendly}
          dataQa="budget-friendly"
        />
      )}
      {priceDrops.length > 0 && (
        <RecCarousel
          title={CarouselType.PriceDrops}
          vehicles={priceDrops}
          dataQa="price-drops"
        />
      )}
    </div>
  ) : (
    <div className="flex flex-col gap-24">
      <CarouselSkeleton Tile={VehicleDetailsTileSkeleton} />
      <CarouselSkeleton Tile={VehicleDetailsTileSkeleton} />
      <CarouselSkeleton Tile={VehicleDetailsTileSkeleton} />
      <CarouselSkeleton Tile={VehicleDetailsTileSkeleton} />
      <CarouselSkeleton Tile={VehicleDetailsTileSkeleton} />
    </div>
  );
}
